module.exports = __webpack_public_path__ + "img/dab_fatim.400c77c8.jpg";